import React, { useState } from "react";
import styles from "../FinanceDetailV2.module.scss";
import tools from "../../../../helpers/tools";
import Loader from "../../../common/Loader";

const DevisSearchV2 = ({
  quotationData,
  selectedQuotations,
  disabled,
  isLoading,
  defaultReference = "",
  onSelect,
  onUnselect,
  onSearch,
}) => {
  // En mode modale, on pré-remplit la référence du dossier d'origine pour que
  // l'utilisateur retrouve d'un clic les autres lignes du même dossier.
  const [search, setSearch] = useState({
    clientName: "",
    reference: defaultReference,
    brand: "",
    brandModel: "",
  });
  const [openGroups, setOpenGroups] = useState({});

  const handleChange = (e) => {
    setSearch({ ...search, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    onSearch(search);
  };

  const handleReset = () => {
    const empty = { clientName: "", reference: "", brand: "", brandModel: "" };
    setSearch(empty);
    onSearch(empty);
  };

  const toggleGroup = (k) => {
    setOpenGroups((prev) => ({ ...prev, [k]: !prev[k] }));
  };

  const isSelected = (uuid) =>
    selectedQuotations.some((q) => q.quotation === uuid);

  const handleCheck = (e, quotationObj) => {
    if (e.target.checked) {
      onSelect(quotationObj);
    } else {
      onUnselect(quotationObj.uuid);
    }
  };

  return (
    <div style={{ marginTop: 10 }}>
      {/* Search bar */}
      <form onSubmit={handleSubmit} className={styles.searchBar}>
        <div className={styles.searchField} style={{ flex: 2 }}>
          <label className={styles.searchLabel}>Client</label>
          <input
            className={styles.searchInput}
            name="clientName"
            value={search.clientName}
            onChange={handleChange}
            placeholder="Nom du client..."
          />
        </div>
        <div className={styles.searchField} style={{ flex: 1.5 }}>
          <label className={styles.searchLabel}>Référence</label>
          <input
            className={styles.searchInput}
            name="reference"
            value={search.reference}
            onChange={handleChange}
            placeholder="D_2025..."
          />
        </div>
        <div className={styles.searchField} style={{ flex: 1 }}>
          <label className={styles.searchLabel}>Marque</label>
          <input
            className={styles.searchInput}
            name="brand"
            value={search.brand}
            onChange={handleChange}
            placeholder="Toutes"
          />
        </div>
        <div className={styles.searchField} style={{ flex: 1 }}>
          <label className={styles.searchLabel}>Modèle</label>
          <input
            className={styles.searchInput}
            name="brandModel"
            value={search.brandModel}
            onChange={handleChange}
            placeholder="Tous"
          />
        </div>
        <div className={styles.searchActions}>
          <button type="submit" className={styles.searchBtn}>
            <i className="fa fa-search" />
          </button>
          <button
            type="button"
            className={styles.searchResetBtn}
            onClick={handleReset}
          >
            <i className="fa fa-times" />
          </button>
        </div>
      </form>

      {/* Results */}
      {isLoading && <Loader />}
      {!isLoading && (!quotationData || quotationData.length === 0) && (
        <div className={styles.resultsEmpty}>
          <i className="fa fa-search" />
          <span>Recherchez des dossiers pour sélectionner des devis</span>
        </div>
      )}
      {quotationData && quotationData.length > 0 && (
        <>
        <div className={styles.resultsCounter}>
          {quotationData.reduce((sum, g) => sum + g.quotations.filter((q) => q.status === 2).length, 0)} devis trouvé{quotationData.reduce((sum, g) => sum + g.quotations.filter((q) => q.status === 2).length, 0) > 1 ? "s" : ""} dans {quotationData.length} dossier{quotationData.length > 1 ? "s" : ""}
        </div>
        <div className={styles.resultsList}>
          {quotationData
            .sort((a, b) => (a.reference > b.reference ? 1 : -1))
            .map((group, k) => {
              const validQuotations = group.quotations.filter(
                (q) => q.status === 2,
              );
              if (validQuotations.length === 0) return null;

              const isOpen = openGroups[k] !== false;

              return (
                <div key={"grp-" + k}>
                  <div
                    className={styles.resultGroupHeader}
                    onClick={() => toggleGroup(k)}
                  >
                    <i
                      className={`fa fa-chevron-${isOpen ? "down" : "right"}`}
                      style={{ fontSize: "0.6rem", width: 10 }}
                    />
                    <span className={styles.resultGroupRef}>
                      {group.reference}
                    </span>
                    <span className={styles.resultGroupMeta}>
                      {validQuotations.length} ligne
                      {validQuotations.length > 1 ? "s" : ""}
                    </span>
                    <span className={styles.resultGroupDate}>
                      {tools.formatDate(group.updatedAt)}
                    </span>
                  </div>

                  {isOpen &&
                    validQuotations.map((q) => {
                      const checked = isSelected(q.uuid);
                      return (
                        <div
                          key={q.uuid}
                          className={`${styles.resultItem} ${checked ? styles.resultItemSelected : ""}`}
                        >
                          <label className={styles.resultCheckbox}>
                            <input
                              type="checkbox"
                              checked={checked}
                              onChange={(e) => handleCheck(e, q)}
                              disabled={disabled}
                            />
                            <span
                              className={`${styles.checkmark} ${checked ? styles.checkmarkChecked : ""}`}
                            >
                              {checked && (
                                <i
                                  className="fa fa-check"
                                  style={{ fontSize: 8 }}
                                />
                              )}
                            </span>
                          </label>
                          <div className={styles.resultItemInfo}>
                            <div className={styles.resultItemRef}>
                              {q.reference}
                              {q.quantity > 1 && (
                                <span className={styles.resultItemQty}>
                                  x{q.quantity}
                                </span>
                              )}
                            </div>
                            <div className={styles.resultItemMeta}>
                              {q.vehicle?.brand && (
                                <span>
                                  {q.vehicle.brand?.name || q.vehicle.brand}{" "}
                                  {q.vehicle.brandModel?.name || q.vehicle.model}
                                </span>
                              )}
                              {q.dur && <span>{q.dur} mois</span>}
                              {q.vehicle?.investAmtHT && (
                                <span>
                                  {Number(
                                    q.vehicle.investAmtHT,
                                  ).toLocaleString("fr-FR")}{" "}
                                  € HT
                                </span>
                              )}
                            </div>
                          </div>
                        </div>
                      );
                    })}
                </div>
              );
            })}
        </div>
        </>
      )}
    </div>
  );
};

export default DevisSearchV2;
